import { useEffect, useRef } from 'react'
import styles from './Downloads.module.scss'
import useHubSpotGenerate from 'hooks/useHubSpotGenerate'
import LeftContents from './LeftContents'
import { LeftContentDataType } from './types/types'
import { gsap, Power4 } from 'gsap'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'
import MailmagazineLink from 'components/mailmagazine/MailmagazineLink/MailmagazineLink'

gsap.registerPlugin(ScrollTrigger)

const leftContentData: LeftContentDataType = {
  titleVol: <>PMMのすべて ーPdMと一体化したプロダクト成功の方程式－</>,
  alt: 'PMMのすべて ーPdMと一体化したプロダクト成功の方程式－',
  readText: (
    <>
      なぜ、プロダクトの成長にPdMとPMMの分業が必要なのか、PMMの役割・導入プロセス・組織設計を体系的に整理した全30ページのホワイトペーパー
    </>
  ),
  imgLarge: '/images/img/download/pmm-complete-guide/thumbnail_pmm.webp',
  imgCapture: '/images/img/download/pmm-complete-guide/capture_pmm.webp',
  firstContentTitle: 'このような方におすすめ',
  firstHalf: (
    <>
      この資料ではプロダクトの成長に課題を感じている方、開発領域とマーケティング領域の役割分担を最適化したい方に対して、PdM（プロダクトマネージャー）とPMM（プロダクトマーケティングマネージャー）の分業体制によるプロダクト成長モデルについて解説した資料です。
    </>
  ),
  secondContentTitle: 'この資料でわかること',
  secondHalf1: 'PdMとの役割分担によるプロダクト成長モデル',
  secondHalf2: 'PMMの役割定義・関与範囲・必要スキル',
  secondHalf3: '組織導入に向けた設計とステップ',
}

const DownloadPmmChecklist: React.FC = () => {
  const title_category = useRef<HTMLSpanElement>(null)
  const title_page = useRef<HTMLSpanElement>(null)
  useHubSpotGenerate('na1', '9395227', 'b40619db-f6e1-4987-828a-557eb2affd22', '#hbspt')
  useEffect(() => {
    gsap.set([title_category.current, title_page.current, `.${styles.read_text}`, `.${styles.section}`], {
      opacity: 0,
      y: 50,
    })

    const timeline = gsap.timeline({
      defaults: {
        opacity: 0,
        y: 50,
        duration: 1,
        ease: Power4.easeOut,
      },
    })

    const commonTo = { opacity: 1, y: 0 }

    timeline
      .to(title_category.current, commonTo, 0.2)
      .to(title_page.current, commonTo, 0.5)
      .to(`.${styles.read_text}`, commonTo, 0.8)
      .to(`.${styles.section}`, commonTo, 1.1)
  }, [])

  return (
    <article className={`${styles.main} downloadArea`}>
      <section className={styles.contents}>
        <h1 className={styles.ttl}>
          <span ref={title_category}>Download</span>
          <span ref={title_page}>{leftContentData.titleVol}</span>
        </h1>
        <p className={styles.read_text}>{leftContentData.readText}</p>
        <section className={styles.section}>
          <LeftContents leftContentData={leftContentData} isSecondContent={true} />
          <div className={styles.content}>
            <div className={styles.title_group}>
              <p className={styles.whitepaper}>
                ご入力いただいたメールアドレス宛に、資料ダウンロード用URLを送付いたします。
              </p>
              <p className={styles.notice}>※ 全ての項目をご入力ください。</p>
            </div>
            <div id="hbspt"></div>
          </div>
        </section>
      </section>
      <MailmagazineLink />
    </article>
  )
}

export default DownloadPmmChecklist
